<template>
    <div id="AboutUs">
        <div class="header-wrapper" :class="{'fixed':isFixed}">
            <img class="logo" src="../assets/images/logo.png" alt="" />
            <div class="header-content">
                <ul>
                    <li :class="{'active':activeIndex === 0}" @click="shiftTitle(0)">
                        <span>首页</span>
                    </li>
                    <li :class="{'active':activeIndex === 1}" @click="shiftTitle(1)">
                        <span>小程序下单</span>
                    </li>
                    <li :class="{'active':activeIndex === 2}" @click="shiftTitle(2)">
                        <span>一键下单</span>
                    </li>
                    <li :class="{'active':activeIndex === 3}" @click="shiftTitle(3)">
                        <span>关于极吼吼</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="banner-content">
            <div class="banner-bg"></div>
            <img src="../assets/images/abanner.png" alt="" />
        </div>
        <div class="aboutus-content">
            <div class="history-content">
                <h1>
                    <p>我们的发展历程</p>
                    <span>OUR DEVELOPMENT HISTORY</span>
                </h1>
                <ul class="time-line">
                    <li>2015年</li>
                    <li>2017年</li>
                    <li>2019年</li>
                    <li>2020年</li>
                </ul>
                <Tabs>
                    <TabPane label="项目启动">
                        <dl class="history-item">
                            <dt>
                                <img src="../assets/images/alex-kotliarskyi-QBpZGqEMsKg-unsplash.png" alt="" />
                            </dt>
                            <dd>
                                <p>极吼吼总部位于上海，项目成立初心，是为上海市民提供方便快捷的手机维修服务，无论在家、办公室、还是咖啡馆，一个电话、一键下单就能解决屏碎、电池不耐用、进水不开机等问题。提供经过严格检测筛选的部件，承诺180天的质保，让用户修得省心放心。</p>
                            </dd>
                        </dl>
                    </TabPane>
                    <TabPane label="扩展业务">
                        <dl class="history-item">
                            <dt>
                                <img src="../assets/images/austin-distel-mpN7xjKQ_Ns-unsplash.png" alt="" />
                            </dt>
                            <dd>
                                <p>团队规模壮大的同时，极吼吼为满足广大用户的实际需求，增加经营项目，扩充Macbook、iMac、安卓等产品业务，新增服务城市：北京，与多个平台及企业密切合作，提供多样化的定制产品，输出上门服务的成功经验和资源。</p>
                            </dd>
                        </dl>
                    </TabPane>
                    <TabPane label="蓬勃发展">
                        <dl class="history-item">
                            <dt>
                                <img src="../assets/images/pedro-lastra-Nyvq2juw4_o-unsplash.png" alt="" />
                            </dt>
                            <dd>
                                <p>历经四年打磨，极吼吼成为上海知名维修服务品牌，已为90余万名用户解决维修、回收、置换等需求，团队从几十人发展至上百人，提供了诸如7x24小时客服，这样的精细化的服务，也和苹果公司合作，采购官方部件提供苹果官方标准的维修业务，覆盖高端用户群体。</p>
                            </dd>
                        </dl>
                    </TabPane>
                    <TabPane label="放眼未来">
                        <dl class="history-item">
                            <dt>
                                <img src="../assets/images/josh-calabrese-Ca8r0PSWg9Q-unsplash.png" alt="" />
                            </dt>
                            <dd>
                                <p>2020年是公司发展极其重要的一年，可以预见，5G网络的大面积商用，将会让数码3C领域焕发新生，作为3C服务提供商，极吼吼有责任和义务，推动更新更完善的售后服务体系建设，满足顾客日益丰富的业务需求，脱离单一维修形式的束缚，还原服务的本质。</p>
                            </dd>
                        </dl>
                    </TabPane>
                </Tabs>
            </div>
            <div class="speacial-content">
                <h1>
                    <p>服务特色</p>
                    <span>SERVICE FEATURES</span>
                </h1>
                <ul>
                    <li>
                        <img src="../assets/images/kf.png" alt="" />
                        <p>服务保障：全天候客服在线</p>
                    </li>
                    <li>
                        <img src="../assets/images/h3.png" alt="" />
                        <p>技术保障：通过考核认证全职工程师</p>
                    </li>
                    <li>
                        <img src="../assets/images/shouhou.png" alt="" />
                        <p>售后保障：屏幕电池享受180天质保</p>
                    </li>
                </ul>
            </div>
            <div class="hohofast-content">
                <h1>
                    <p>极吼吼</p>
                    <span>HOHOFAST</span>
                </h1>
                <dl>
                    <dt>公司介绍</dt>
                    <dd>上海极吼吼是一家以上门处理手机/平板/电脑/可穿戴设备等数码设备的维修、回收、检测业务为主的售后服务提供商。</dd>
                     <dd>
                        旗下子品牌有：极吼吼（维修）、极收收（回收）、极享Plus（Apple 官方部件维修）、极焕焕（换新）等。
                        总部位于上海，成立四年多来，已为80余万名iPhone、iPad、Mac、安卓等主流数码产品用户，解决维修、回收等需求，微信平台粉丝30万，一篇推文阅读量在2～5万。
                    </dd>
                    <dd>
                        以壮大中的维修/回收技能人才培训项目为基础，充实自身的同时，以外包模式对外输送掌握成熟维修/回收技能的工程师，同时输出多媒体化的教材资源，为B端客户提供包括：呼叫中心、上门维修、寄修、上门回收等业务在内的整合一体化成熟方案。
                    </dd>
                    <dd>
                        目前在职的分布上海北京两地的上门工程师80余人，上海驻店主板级工程师十余人，客服中心30余人，与爱回收、盒马、转转、携程等知名企业保持良好合作关系。
                    </dd>
                    <dd>
                        以上门、到店、寄修、回收、置换、7x24小时服务等业务的开拓，推动完整服务体系的建设，满足顾客日益丰富的业务需求，脱离单一维修形式的束缚，还原服务的本质，是极吼吼一直在努力的方向和目标。
                    </dd>
                </dl>
                <dl>
                    <dt>相关品牌</dt>
                    <dd>极吼吼：主营Apple、华为、小米等品牌设备的上门维修</dd>
                    <dd>极收收：主营手机、平版、电脑、数码周边等3C数码的上门回收</dd>
                    <dd>极享Plus：Apple 官方部件采购商，为消费者提供便捷的官方部件上门维修服务</dd>
                    <dd>极焕焕：提供一口价的3C数码产品上门置换服务，没有繁琐的估价流程，无需等待快递，第一时间体验最新数码科技产品。</dd>

                </dl>
               
            </div>
        </div>
        <BackTop :height="400"></BackTop>
        <p class="copyright">Copyright&nbsp;&nbsp;极吼吼&nbsp;&nbsp;©&nbsp;&nbsp;2018-2022&nbsp;&nbsp;&nbsp;&nbsp;<a style="text-decoration: none;color:#656565;" class="ui-link" href="http://beian.miit.gov.cn">沪ICP备15055722号-1</a>&nbsp;&nbsp;&nbsp;&nbsp;
        <a  class="ui-link" style="text-decoration:none;color:#656565;" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502001871"><img class="ui-img" src="../assets/images/sh.png">&nbsp;沪公网安备 31010502001871号</a>
        </p>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {BackTop} from 'iview';
    export default{
        components:{
            BackTop
        },
        data(){
            return{
                isFixed:false,
                activeIndex:3,
            }
        },
        mounted(){
            //页面加载后添加滚动事件
            this.$nextTick(function () {
                window.addEventListener('scroll', this.onScroll);
                this.toTop(0);
            });       
        },
        destroyed: function () {
            //离开页面清除（移除）滚轮滚动事件
            window.removeEventListener('scroll', this.onScroll);

        },
        methods:{
            shiftTitle(index){
                if(index < 3){
                    this.$router.replace('/')
                }
                let activeIndex = index.toString();
                sessionStorage.setItem('activeIndex', activeIndex);
            },
            onScroll () {
                //获取滚动对象到窗体顶部的距离 chrome&Firefox&Safari
                let scrolled = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
               if(scrolled < 100){
                    this.isFixed = false;
                }else{
                    this.isFixed = true;
                }
                if(scrolled < 5){
                    //滚动清零
                    this.toTop(0);
                }
                console.log(scrolled)
            },
            toTop(scrollTop){
                document.body.scrollTop = scrollTop;
                document.documentElement.scrollTop = scrollTop;
                window.pageYOffset = scrollTop;
            }
        }
    }
</script>
<style lang="less">
    #AboutUs{
        .header-wrapper{
            position: relative;
            padding:57px 140px 0;
            border-bottom:1px solid #f5f5f5;
            transition: .5s;
            position: fixed;
            width: 100%;
            left:0;
            top:0;
            background:rgba(255,255,255,.8);
            z-index:9999999;
            transition: .3s;
            img.logo{
                position: absolute;
                left:140px;
                top:10px;
                width: 103px;
                height: 103px;
            }
            .header-content{
                width: 630px;
                margin:0 auto ;
                height: 44px;
                ul{
                    display: -webkit-box; /* Chrome 4+, Safari 3.1, iOS Safari 3.2+ */  
                    display: -moz-box; /* Firefox 17- */  
                    display: -webkit-flex; /* Chrome 21+, Safari 6.1+, iOS Safari 7+, Opera 15/16 */  
                    display: -moz-flex; /* Firefox 18+ */  
                    display: -ms-flexbox; /* IE 10 */  
                    display: flex; /* Chrome 29+, Firefox 22+, IE 11+, Opera 12.1/17/18, Android 4.4+ */
                    -webkit-box-pack: justify;
                    -ms-flex-pack: justify;
                    -webkit-justify-content: space-between;
                    justify-content: space-between;
                    li{
                        text-align:center;
                        line-height:1.8;
                        width: 80px;
                        span{
                            font-size:16px;
                            font-family:PingFang SC;
                            font-weight:500;
                            color:rgba(196,196,196,1);
                            display:block;
                            height: 44px;
                            position: relative;
                            cursor:pointer;
                            -moz-user-select: none;
                            -webkit-user-select: none;
                            -ms-user-select: none;
                            &:after{
                                content:'';
                                position:absolute;
                                left:32%;
                                bottom:0;
                                width: 36%;
                                height:4px;
                                display:block;
                                background: transparent;
                                border-radius:4px;
                            }
                        }
                    }
                    li.active{
                        span{
                            color:rgba(29,29,29,1);
                            font-weight:bold;
                            &:after{
                                background: #1D1D1D;
                            }
                        }
                    }
                }
            } 
        }
        .fixed{
            box-shadow: 0 5px 5px -5px #eee;
            .header-content{
                ul{
                    li{
                        span{
                            color:rgba(29,29,29,1);
                        }
                    }
                    li.active{
                        span{
                            color:#535dfa;
                            &:after{
                                background: #535dfa;
                            }
                        }
                    }
                }
            }
        }
        .banner-content{
            position:relative;
            margin-top:103px;
            img{
                display:block;
                width:100%;
                height:auto;
            }
            .banner-bg{
                position:absolute;
                width:100%;
                height:100%;
                left:0;
                top:0;
                background:rgba(0,0,0,.3);
            }
            
        }
        .aboutus-content{
            width:1080px;
            margin:0 auto;
            .history-content{
                margin-bottom:80px;
                padding-bottom:50px;
                border-bottom:1px dashed #ddd;
                h1{
                    margin:80px 0;
                    text-align:left;
                    p{
                        font-size:30px;
                        font-family:PingFang SC;
                        font-weight:600;
                        line-height:1.8;
                        color:rgba(29,29,29,1);
                        opacity:1;
                    }
                    span{
                        font-size:14px;
                        font-family:Avenir;
                        font-weight:500;
                        line-height:1.8;
                        color:rgba(196,196,196,1);
                        opacity:1;
                    }
                }
                ul{
                    display: -webkit-box; /* Chrome 4+, Safari 3.1, iOS Safari 3.2+ */  
                    display: -moz-box; /* Firefox 17- */  
                    display: -webkit-flex; /* Chrome 21+, Safari 6.1+, iOS Safari 7+, Opera 15/16 */  
                    display: -moz-flex; /* Firefox 18+ */  
                    display: -ms-flexbox; /* IE 10 */  
                    display: flex; /* Chrome 29+, Firefox 22+, IE 11+, Opera 12.1/17/18, Android 4.4+ */
                    -webkit-box-pack: justify;
                    -ms-flex-pack: justify;
                    -webkit-justify-content: space-between;
                    justify-content: space-between;
                    margin-bottom:18px;
                    li{
                        text-align:center;
                        font-size:20px;
                        font-family:PingFang SC;
                        font-weight:600;
                        line-height:50px;
                        color:rgba(29,29,29,1);
                        opacity:1;
                        -webkit-flex:1;
                        -moz-flex:1;
                        -ms-flex:1;
                        flex:1
                    }
                }
                .history-item{
                    display: -webkit-box; /* Chrome 4+, Safari 3.1, iOS Safari 3.2+ */  
                    display: -moz-box; /* Firefox 17- */  
                    display: -webkit-flex; /* Chrome 21+, Safari 6.1+, iOS Safari 7+, Opera 15/16 */  
                    display: -moz-flex; /* Firefox 18+ */  
                    display: -ms-flexbox; /* IE 10 */  
                    display: flex; /* Chrome 29+, Firefox 22+, IE 11+, Opera 12.1/17/18, Android 4.4+ */
                    -webkit-box-pack: justify;
                    -ms-flex-pack: justify;
                    -webkit-justify-content: space-between;
                    justify-content: space-between;
                    padding:20px 0;
                    dt{
                        img{
                            width: 260px;
                            height: auto;
                            display:block;
                        }
                        padding-right:30px;
                    }
                    dd{
                        p{
                            font-size:20px;
                            font-family:PingFang SC;
                            font-weight:400;
                            line-height:1.8;
                            color:rgba(101,101,101,1);
                            opacity:1;
                            margin-bottom:30px;
                            text-align:justify;

                        }
                    }
                }
                .ivu-tabs-ink-bar{
                    width:25% !important;
                }
                .ivu-tabs-nav{
                    width: 100%!important;
                    padding-bottom:20px;
                    .ivu-tabs-tab{
                        width: 25% !important;
                        padding:0;
                        margin:0;
                        line-height:80px;
                        transition: .1s!important;
                        font-size:20px;
                        font-family:PingFang SC;
                        font-weight:600;
                        color:rgba(29,29,29,1);
                        -moz-user-select: none;
                        -webkit-user-select: none;
                        -ms-user-select: none;
                        background: #F8F8F8;
                    }
                    .ivu-tabs-tab-active{
                        background:rgba(83,93,250,1);
                        opacity:1;
                        color:#fff;
                        font-size:20px;
                        font-family:PingFang SC;
                        font-weight:600;
                        color:rgba(255,255,255,1);
                        opacity:1;
                        position: relative;
                        &:after{
                            content:'';
                            display: block;
                            position: absolute;
                            width:0!important; 
                            height:0!important; 
                            border-top:20px solid rgba(83,93,250,1); 
                            border-left:12px solid transparent; 
                            border-right:12px solid transparent;
                            background: transparent;
                            bottom:-17px !important;
                            left:124px!important;
                        }

                    }
                    .ivu-tabs-nav-scroll{
                        padding-bottom: 20px;

                    }
                    .ivu-tabs-ink-bar{
                        display: none !important;
                        width:0!important; 
                        height:0!important; 
                        border-top:20px solid rgba(83,93,250,1); 
                        border-left:12px solid transparent; 
                        border-right:12px solid transparent;
                        background: transparent;
                        bottom:-17px !important;
                        left:124px!important;
                    }

                }
                .ivu-tabs-bar{
                    border-color:transparent!important;
                }
            }
            .speacial-content{
                margin-bottom:80px;
                padding-bottom:50px;
                border-bottom:1px dashed #ddd;
                h1{
                    margin:80px 0;
                    text-align:left;
                    p{
                        font-size:30px;
                        font-family:PingFang SC;
                        font-weight:600;
                        line-height:1.8;
                        color:rgba(29,29,29,1);
                        opacity:1;
                    }
                    span{
                        font-size:14px;
                        font-family:Avenir;
                        font-weight:500;
                        line-height:1.8;
                        color:rgba(196,196,196,1);
                        opacity:1;
                    }
                }
                ul{
                    display: -webkit-box; /* Chrome 4+, Safari 3.1, iOS Safari 3.2+ */  
                    display: -moz-box; /* Firefox 17- */  
                    display: -webkit-flex; /* Chrome 21+, Safari 6.1+, iOS Safari 7+, Opera 15/16 */  
                    display: -moz-flex; /* Firefox 18+ */  
                    display: -ms-flexbox; /* IE 10 */  
                    display: flex; /* Chrome 29+, Firefox 22+, IE 11+, Opera 12.1/17/18, Android 4.4+ */
                    -webkit-box-pack: justify;
                    -ms-flex-pack: justify;
                    -webkit-justify-content: space-between;
                    justify-content: space-between;
                    li{
                        width: 355px;
                        img{
                            width: 355px;
                            height: auto;
                            display:block;
                            margin-bottom:20px;
                        }
                        p{
                            font-size:16px;
                            font-family:PingFang SC;
                            font-weight:500;
                            color:rgba(29,29,29,1);
                            opacity:1;
                            text-align:left;
                        }
                    }
                }
            }
            .hohofast-content{
                margin-bottom:100px;
                h1{
                    margin:80px 0;
                    text-align:left;
                    p{
                        font-size:30px;
                        font-family:PingFang SC;
                        font-weight:600;
                        line-height:1.8;
                        color:rgba(29,29,29,1);
                        opacity:1;
                    }
                    span{
                        font-size:14px;
                        font-family:Avenir;
                        font-weight:500;
                        line-height:1.8;
                        color:rgba(196,196,196,1);
                        opacity:1;
                    }
                }
                dl{
                    dt{
                        font-family:PingFangSC-Medium;
                        font-size:20px;
                        font-weight:600;
                        color:#1D1D1D;
                        text-align:left;
                        margin-bottom:20px;
                    }
                    dd{
                        font-family:PingFangSC-Medium;
                        font-size:19px;
                        font-weight:500;
                        color:#656565;
                        text-align:justify;
                        margin-bottom:20px;
                        line-height:1.8;
                    }
                }
            }
            
        }
        .copyright{
            font-size:14px;
            font-family:PingFang SC;
            font-weight:400;
            line-height:60px;
            color:rgba(101,101,101,1);
            opacity:1;
            border-top:1px solid #f5f5f5;
            border-bottom:1px solid #f5f5f5;
            text-align:center;
            
        }

    }
</style>


// WEBPACK FOOTER //
// src/views/AboutUs.vue